 <!-- Navbar content here -->
 <nav class="navbar navbar-expand-lg">
    <div class="navbar-container container-fluid">
        <a class="navbar-brand" href="#">
            <img src="assets/images/navbar/northstar-logo.png" alt="">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item nav-user-profile-item">
                <a class="nav-link nav-user-profile-link" aria-current="page" *ngIf="user">
                    <div class="user-profile">
                        <span>{{user.firstName.substring(1, 0).toUpperCase()}}</span>
                    </div>
                    <div class="user-content">
                        <p class="user-content-name">{{user.firstName}} {{user.lastName}}</p>
                        <p class="user-content-span">View Profile</p>
                    </div>
                    <div class="d-flex align-items-center ms-5 logout" style="cursor: pointer;" (click)="logout()">
                        <div class="mr-3">
                          <img class="logout-img" src="assets\images\navbar\logout.png">
                        </div>
                        <p class="mb-0 inter-regular logout-text">Log Out</p>
                    </div>
                </a>
            </li>
        </ul>
        </div>
    </div>
</nav>
